export const offsetCalculationTypes = {
  "": "Select how offset is calculated",
  today: `That day's zman`,
  earliest_of_week: "Earliest zman of the week (Sunday-Shabbos)",
  earliest_of_week_weekday: "Earliest zman of the week (Sunday-Thursday)",
  latest_of_week: "Latest zman of the week (Sunday-Shabbos)",
  latest_of_week_weekday: "Latest zman of the week (Sunday-Thursday)",
};